import React, { createContext, useEffect, useMemo, useState } from 'react';
import {
  useBoolean,
  useToastr,
  usePagination,
  paginationReturnType,
  useTabStorage,
  usePaginationSessionStorage,
} from '@laxmimanogna/code-quick-components';
import accountsRepository from '../repositories/AccountsRepository';
import { successToast } from '../components/successToast';
import { ACCOUNTS_FILTER_OPTIONS, ACCOUNTS_FILTER_OPTIONS_TO_ACCOUNT_QUERY_MAP } from '../constants/constants';
import { ACCOUNTS_PAGE_NAME, ACCOUNTS_TABLE_NAME } from '../pages/accounts/constants';

export const AccountContext = createContext({
  isLoadingAccountsList: false,
  accountsList: [],

  // specialty related
  specialtyOptions: [],
  isFetchingSpecialtyOption: false,
  isCreatingSpecialtyOption: false,
  fetchSpecialtyOptions: async () => null,
  createSpecialtyOption: async specialtyName => null,

  // insurance related
  insuranceOptions: [],
  isFetchingInsurance: false,
  isCreatingInsurance: false,
  fetchInsuranceOptions: async () => null,
  createInsuranceOption: async insuranceName => null,

  // ehr related
  ehrOptions: [],
  isFetchingEHR: false,
  isCreatingEHR: false,
  fetchEHROptions: async () => { },
  createEHROptions: async optionName => { },

  isDepartmentLoading: false,
  onDeleteDepartment: async () => { },
  getDepartment: async () => { },
  createDepartment: async () => { },
  updateDepartment: async () => { },
  updatePartialDepartmentInfo: async () => { },
  isDepartmentUpdating: false,
  errorObject: {},

  //hospital
  updateHospital: async () => { },
  updatePartialHospitalInfo: async () => { },
  isHospitalUpdating: false,
  onDeleteHospital: async () => { },
  getAccountDeletionPreview: async () => null,
  permanentDeleteAccount: async () => { },
  isPermanentDeleteLoading: false,
  //account
  getAccount: async () => { },
  getHospital: async () => { },
  deleteAccount: async () => { },
  account: {},
  hospital: {},
  department: {},
  allDeparments: {},
  provider: {},
  departmentDropdown: [],
  setDepartmentDropdown: () => { },
  getDepartmentDropdown: async () => { },
  createHospital: async () => { },

  fetchHospital: async () => { },
  hospitalData: [],
  isGettingHospitalData: false,

  getProviderEmailByKeyword: () => { },
  createProvider: () => { },
  isProviderCreating: false,
  isProviderDeleting: false,
  isProviderUpdating: false,
  moodleAccountCreate: async () => {},
  isMoodleAccountCreating: false,
  moodleAccountUpdate: async () => {},
  isMoodleAccountUpdating: false,
  moodleAccountDelete: async () => {},
  isMoodleAccountDeleting: false,
  syncProvidersWithMoodle: async () => {},
  moodleSyncLoading: false,
  getProvidersByDeparment: () => { },
  getProvider: () => { },
  setProviderData: () => { },
  onProviderUpdate: () => { },
  updatePartialProviderInfo: () => {},
  onDeleteProvider: () => { },
  //pagination
  getAccountsList: paginationReturnType,

  // create health System
  createHealthSystem: async payload => { },
  isCreatingHealthSystem: false,

  // loading health system
  isGettingHealthSystemData: false,
  isGettingAllDepartmentData: false,

  healthSystem: {},
  getHealthSystem: async healthSystemId => {},
  getAllDepartmentSByHS: async healthSystemID => {},

  // update health system
  updateHealthSystemInformation: async (healthSystemid, payload) => { },
  updatePartialHealthSystemInfo: async () => { },
  isHealthSystemUpdating: false,

  // healthsystem_validation
  getHealthSystemNames: async () => { },
  hsNamesAndPrefix: [],

  // user mail ids
  getUsersMailId: async () => { },
  usersMailIds: [],
  isFetchingPhysicians: false,

  // hospital
  cqHospitalsData: async () => { },
  hospitalDatas: [],

  // updated hospital
  updatedHospitalList: {},
  isCreatingHospital: false,
  accountFilters: {},
  setAccountFilters: () => { },
  setSpecialtyOptions: () => { },

  //Qualification
  getQualifications: async () => { },
  createQualification: async () => { },
  isQualificationCreating: false,

  // archived accounts
  isLoadingArchivedAccountsList: false,
  archivedAccountsList: [],
  getArchivedAccountsList: paginationReturnType,
  restoreAccount: async () => {},
  archivedAccountFilters: {},
  setArchivedAccountFilters: () => {},
  handleApplyFilter: () => {},

});

const AccountsProvider = ({ children }) => {
  const toast = useToastr();
  const tabStorage = useTabStorage();
  const [isLoadingAccountsList, ilalState] = useBoolean(false);
  const [accountsList, setAccountsList] = useState([]);

  // Specialty Options related states
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [isFetchingSpecialtyOption, ifsoState] = useBoolean(false);
  const [isCreatingSpecialtyOption, icsoState] = useBoolean(false);

  // Insurance Options related states
  const [insuranceOptions, setInsuranceOptions] = useState([]);
  const [isFetchingInsurance, ifiState] = useBoolean(false);
  const [isCreatingInsurance, icfState] = useBoolean(false);

  // EHR options related states
  const [ehrOptions, setEHROptions] = useState([]);
  const [isFetchingEHR, ifeState] = useBoolean(false);
  const [isCreatingEHR, iceState] = useBoolean(false);

  const [isDepartmentUpdating, iduState] =  useBoolean(false);
  const [isDepartmentLoading, idlState] = useBoolean(false);
  const [errorObject, setErrorObject] = useState({});
  const [isHospitalUpdating, ihuState] = useBoolean(false);
  const [isPermanentDeleteLoading, ipdlState] = useBoolean(false);

  const [account, setAccount] = useState({});
  const [hospital, setHospital] = useState({});
  const [department, setDepartment] = useState({});
  const [provider, setProvider] = useState({});
  const [allDeparments, setAllDepartments] = useState({});

  // Hospital related states
  const [hospitalData] = useState([]);
  const [isGettingHospitalData, ighdState] = useBoolean(false);

  const [accountListCount, setAccountListCount] = useState(0);
  const [providerData, setProviderData] = useState([]);

  const getAccountsList1 = usePagination(getAccountsList);
  const getArchivedAccountsList1 = usePagination(getArchivedAccountsList);
  const [departmentDropdown, setDepartmentDropdown] = useState([
    { label: 'Cardiology', value: 1, id: 1 },
  ]);

  const [isCreatingHealthSystem, ichsState] = useBoolean(false);
  const [isProviderCreating, ipcState] = useBoolean(false);
  const [isProviderDeleting, ipdState] = useBoolean(false);
  const [isProviderUpdating, ipuState] = useBoolean(false);
  const [isMoodleAccountCreating, setIsMoodleAccountCreating] = useBoolean(false);
  const [isMoodleAccountUpdating, setIsMoodleAccountUpdating] = useBoolean(false);
  const [isMoodleAccountDeleting, setIsMoodleAccountDeleting] = useBoolean(false);
  const [moodleSyncLoading, setMoodleSyncLoading] = useBoolean(false);

  // fetchPhyscians
  const [isFetchingPhysicians, ifpState] = useBoolean(false);

  // health_system_Names_prefix
  const [hsNamesAndPrefix, setHSnamesAndPrefix] = useState([]);

  // user mail ids
  const [usersMailIds, setUserMailIds] = useState([]);

  // hospitals
  const [hospitalDatas, setHospitalDatas] = useState([]);

  // updated hospital
  const [updatedHospitalList, setUpdatedHospitalList] = useState({});

  // create hospital
  const [isCreatingHospital, ichState] = useBoolean(false);

  // health_system related
  const [isGettingHealthSystemData, ighsdState] = useBoolean(false);
  const [isGettingAllDepartmentData, igaddState] = useBoolean(false);
  const [healthSystem, setHealthSystem] = useState({});
  const [isHealthSystemUpdating, ihsuState] = useBoolean(false);

  //Qualification
  const [isQualificationCreating, setIsQualificationCreating] = useBoolean(false);

  //Archived Account
  const [archivedAccountsList, setArchivedAccountsList] = useState([]);
  const [isLoadingArchivedAccountsList, ilaalState] = useBoolean(false);
  const [archivedAccountListCount, setArchivedAccountListCount] = useState(0);
  const [archivedAccountFilters, setArchivedAccountFilters] = useState({});
  // const [accountStatusFilter, setAccountStatusFilter] = useState(ACCOUNTS_FILTER_OPTIONS_TO_ACCOUNT_QUERY_MAP[ACCOUNTS_FILTER_OPTIONS[tabStorage.getTab() || 0]])

  const {
    getPaginationSession
  } = usePaginationSessionStorage();

  const initialFilterParams = useMemo(() => ({
    // this will maintain the search text when we move to audit sheet and return. It will highlight the proper text
    search: getPaginationSession(ACCOUNTS_PAGE_NAME, ACCOUNTS_TABLE_NAME)?.search || '',
    triggerSearch: true,
    ordering: getPaginationSession(ACCOUNTS_PAGE_NAME, ACCOUNTS_TABLE_NAME)?.ordering || '',
    // this will maintain the search text when we move to audit sheet and return. It will highlight the proper text
    accountType: ACCOUNTS_FILTER_OPTIONS[tabStorage.getTab() ?? ACCOUNTS_FILTER_OPTIONS.indexOf("Active")]
  }), []);

  const [accountFilters, setAccountFilters] = useState(
    Object.assign({}, initialFilterParams)
  );

  function showErrorMessage(errors) {
    for (const key in errors) {
        const error = errors[key];
        if (typeof error === "string") {
          toast.showError({ description: error });
        } else if (typeof error === 'object') {
            showErrorMessage(error);
        }
    }
}

  async function fetchSpecialtyOptions(queryParams = {}) {
    try {
      ifsoState.on();
      const response = await accountsRepository.getSpecialtyOptions(
        queryParams
      );
      setSpecialtyOptions(response);
    } catch (e) {
      // TODO: Handle Exception
    } finally {
      ifsoState.off();
    }
  }


  async function getHealthSystem(healthSystemId) {
    try {
      ighsdState.on();
      const response = await accountsRepository.getHealthSystemInformation(
        healthSystemId
      );
      setHealthSystem(response);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      ighsdState.off();
    }
  }

  async function getAllDepartmentSByHS(healthSystemID){
    try {
      igaddState.on();
      const response = await accountsRepository.getAllDepartmentSByHS(
        healthSystemID
      );
      setAllDepartments(response);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      igaddState.off();
    }
  }

  async function updateHealthSystemInformation(healthSystemId, payload) {
    try {
      toast.showLoading({ description: 'Updating' });
      ihsuState.on();
      const response = await accountsRepository.updateHealthSystemInformation(
        healthSystemId,
        payload
      );
      const toastProps = {
        header: 'Success!',
        description: `Updated Successfully`,
      };
      successToast(toast, toastProps);
      return response;
    } catch (error) {
      const response = error.cause;
      showErrorMessage(response);
    } finally {
      ihsuState.off();
    }
  }

  async function updatePartialHealthSystemInfo(healthSystemId, payload, isActivation = false) {
    try {
      toast.showLoading({ description: 'Updating' });
      ihsuState.on();
      

      const res = await accountsRepository.updatePartialHealthSystemInformation(
        healthSystemId,
        payload
      );

      if (isActivation) {
        if (payload['all_clients']) {
          let tmp = healthSystem.hospitals
          for (let i = 0; i < tmp.length; i++) {
            tmp[i].is_active = res.is_active;
          }

          setHealthSystem(prev => ({
            ...prev,
            is_active: res.is_active,
            hospitals: tmp
          }));
        }
        else {
          setHealthSystem(prev => ({
            ...prev,
            is_active: res.is_active,
          }));

        }

      }

      const toastProps = {
        header: 'Success!',
        description: `Updated Successfully`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      const response = error.cause;
      showErrorMessage(response);
    } finally {
      ihsuState.off();
    }

  }

  async function createSpecialtyOption(specialtyName) {
    try {
      icsoState.on();
      if (insuranceOptions.findIndex(d => d.label === specialtyName) === -1) {
        setSpecialtyOptions(prev => [
          ...prev,
          { label: specialtyName, value: specialtyName },
        ]);
      }
    } catch (e) {
      toast.showError({ description: e.toString() });
    } finally {
      icsoState.off();
    }
  }

  async function fetchInsuranceOptions() {
    try {
      ifiState.on();
      const response = await accountsRepository.getInsuranceOptions();
      const insuranceList = response?.map(opt => {
        const options = {
          label: opt.name,
          value: opt.id,
        };
        return options;
      });
      setInsuranceOptions(insuranceList);
    } catch (e) {
      // TODO: Handle Exception
    } finally {
      ifiState.off();
    }
  }

  async function createInsuranceOption(insuranceName) {
    try {
      icfState.on();
      if (insuranceOptions.findIndex(d => d.label === insuranceName) === -1) {
        setInsuranceOptions(prev => [
          ...prev,
          { label: insuranceName, value: insuranceName },
        ]);
      }
    } catch (e) {
      toast.showError({ description: e.toString() });
    } finally {
      icfState.off();
    }
  }

  async function fetchEHROptions() {
    try {
      ifeState.on();
      const response = await accountsRepository.getEHROptions();
      const options = response.map(res => ({ label: res.name, value: res.id }));
      setEHROptions([...options]);
    } catch (e) {
      // TODO: Capture exception
    } finally {
      ifeState.off();
    }
  }

  async function createEHROptions(optionName) {
    try {
      iceState.on();
      if (ehrOptions.findIndex(d => d.label === optionName) === -1) {
        setEHROptions(prev => [
          ...prev,
          { label: optionName, value: optionName },
        ]);
      }
    } catch (e) {
      toast.showError({ description: e.toString() });
    } finally {
      iceState.off();
    }
  }

  const getFilterParams = () => {
    const queryParams = {};
    const { search, ordering, accountType } = accountFilters;
    if (search) queryParams['search'] = search;
    if (ordering) queryParams['ordering'] = ordering;
    if (accountType && accountType !== "Active") queryParams['deleted'] = true

    return queryParams;
  };

  async function getAccountsList(paginationParams) {
    try {
      ilalState.on();
      let payload = { ...getFilterParams(), ...paginationParams}
      if ('deleted' in payload && !payload.deleted) {
        delete payload.deleted;
      }
      const response = await accountsRepository.getHierarchyTree(payload);
      setAccountsList(response.data);
      setAccountListCount(response.count);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error}`,
      });
    } finally {
      ilalState.off();
    }
  }

  const handleApplyFilter = selectedFilters => {
    setAccountFilters(selectedFilters);
  };

  async function fetchHospital(hospitalId) {
    try {
      ighdState.on();
      const response = await accountsRepository.getHospital(hospitalId);
      return response;
    } catch (e) {
      toast.showError({ description: e.toString() });
    } finally {
      ighdState.off();
    }
  }
  // department
  const onDeleteDepartment = async departmentId => {
    //delete function
    try {
      idlState.on();
      await accountsRepository.deleteDepartment(departmentId);
      const toastProps = {
        header: 'Success!',
        description: `${'Department deleted.'}`,
      };
      successToast(toast, toastProps);
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      idlState.off();
    }
  };

  const getDepartment = async departmentId => {
    //delete function
    try {
      idlState.on();
      const res = await accountsRepository.getDepartment(departmentId);
      setDepartment(res);
      return res;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      idlState.off();
    }
  };

  const createDepartment = async body => {
    //delete function
    try {
      idlState.on();
      const res = await accountsRepository.createDepartment(
        body.hospital,
        body
      );
      const toastProps = {
        header: 'Success!',
        description: `${'Department created'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      const duplicateDepartmentError = error.cause;
      showErrorMessage(duplicateDepartmentError)
    } finally {
      idlState.off();
    }
  };

  const updateDepartment = async (departmentId, body) => {
    //delete function
    try {
      idlState.on();
      const res = await accountsRepository.updateDepartment(departmentId, body);
      const toastProps = {
        header: 'Success!',
        description: `${'Department updated'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      const duplicateDepartmentError = error.cause;
      showErrorMessage(duplicateDepartmentError)
    } finally {
      idlState.off();
    }
  };

  const updatePartialDepartmentInfo = async (departmentId, payload, isActivation = false) => {
    try {
      iduState.on();
      const res = await accountsRepository.updatePartialDepartmentInformation(departmentId, payload);

      if (isActivation) {
        if (payload['all_clients']) {
          let tmp = providerData;
          for (let i = 0; i < tmp.length; i++) {
            tmp[i].is_active = res[tmp[i].id];
          }
          setProviderData(tmp);
        }
        
        setDepartment(prev => ({
          ...prev, 
          is_active: res.is_active
        }));
      }

      const toastProps = {
        header: 'Success!',
        description: `${'Department updated'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      showErrorMessage(error.cause);
      return {error: error?.cause?.detail || "ERROR"}
    } finally {
      iduState.off();
    }
  }


  const getAccount = async accountId => {
    //delete function
    try {
      idlState.on();
      const res = await accountsRepository.getAccount(accountId);
      setAccount(res);
      return res;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      idlState.off();
    }
  };

  const getHospital = async hospitalId => {
    //delete function
    try {
      ighdState.on();
      const res = await accountsRepository.getHospital(hospitalId);
      setHospital(res);
      return res;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      ighdState.off();
    }
  };

  const createHospital = async hospitalData => {
    try {
      ichState.on();
      const res = await accountsRepository.createHospital(hospitalData);
      const toastProps = {
        header: 'Success!',
        description: `${'Hospital Created'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      const response = error.cause;
      showErrorMessage(response)
    } finally {
      ichState.off();
    }
  };

  const updatePartialHospitalInfo = async (hospitalId, payload, isActivation = false) => {
    //delete function
    try {
      ihuState.on();

      const res = await accountsRepository.updatePartialHospitalInformation(hospitalId, payload);

      if (isActivation) {
        if (payload['all_clients']) {
          let tmp = hospital.department
          for (let i = 0; i < tmp.length; i++) {
            tmp[i].is_active = res.is_active;
          }

          setHospital(prev => ({
            ...prev,
            is_active: res.is_active,
            department: tmp
          }))

        } else {
          setHospital(prev => ({
            ...prev,
            is_active: res.is_active,
          }))
        }
        

      }

      // I think this is not a list but a single hospital
      // setUpdatedHospitalList(prev => ({
      //   ...prev,
      //   [attribute]: res[attribute]
      // }));

      const toastProps = {
        header: 'Success!',
        description: `${'Hospital updated'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      const response = error.cause;
      showErrorMessage(response);
    } finally {
      ihuState.off();
    }
  };

  const updateHospital = async (hospitalId, body) => {
    //delete function
    try {
      ihuState.on();
      const res = await accountsRepository.updateHospital(hospitalId, body);
      setUpdatedHospitalList(res);
      const toastProps = {
        header: 'Success!',
        description: `${'Hospital updated'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      const response = error.cause;
      showErrorMessage(response);
    } finally {
      ihuState.off();
    }
  };
  const onDeleteHospital = async hospitalId => {
    //delete function
    try {
      ihuState.on();
      await accountsRepository.deleteHospital(hospitalId);
      const toastProps = {
        header: 'Success!',
        description: `${'Hospital deleted.'}`,
      };
      successToast(toast, toastProps);
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      ihuState.off();
    }
  };
  const deleteAccount = async accountId => {
    try {
      idlState.on();
      await accountsRepository.deleteAccount(accountId);
      const temp = accountsList.filter(account => account.id !== accountId);
      setAccountsList([...temp]);
      const toastProps = {
        header: 'Success!',
        description: `${'Account archived.'}`,
      };
      successToast(toast, toastProps);
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      idlState.off();
    }
  };

  const getAccountDeletionPreview = async (accountId) => {
    try {
      const response = await accountsRepository.getAccountDeletionPreview(accountId);
      return response.deletion_summary;
    } catch (error) {
      const error_message =
        error?.cause?.error ??
        error?.message ??
        error;

      toast.showError({
        description: error_message.toString(),
      });
      return null
    }
  };

  const permanentDeleteAccount = async (accountId, confirmationText) => {
    try {
      ipdlState.on();
      await accountsRepository.permanentDeleteAccount(accountId, confirmationText);
      
      // Remove from BOTH lists since we don't know which one it's in
      const tempAccountsList = accountsList.filter(account => account.id !== accountId);
      setAccountsList([...tempAccountsList]);
      
      const tempArchivedList = archivedAccountsList.filter(account => account.id !== accountId);
      setArchivedAccountsList([...tempArchivedList]);
      
      const toastProps = {
        header: 'Success!',
        description: 'Account permanently deleted.',
      };
      successToast(toast, toastProps);
    } catch (error) {
      const error_message =
        error?.cause?.error ??
        error?.message ??
        error;

      toast.showError({
        description: error_message.toString(),
      });
      throw error;
    } finally {
      ipdlState.off();
    }
  };

  const getProviderEmailByKeyword = async keyword => {
    try {
      const response = await accountsRepository.getProviderEmail(keyword);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    }
  };

  const createProvider = async (departmentId, providerBody) => {
    try {
      ipcState.on();
      const response = await accountsRepository.createProvider(
        departmentId,
        providerBody
      );
      
      // If qualification_ids exist, attach them to the provider/client
      if (providerBody.qualification_ids && providerBody.qualification_ids.length > 0) {
        await accountsRepository.qualificationToClient(response.id, providerBody.qualification_ids)
      }

      const toastProps = {
        header: 'Success!',
        description: `${'Provider Created'}`,
      };
      successToast(toast, toastProps);
      return response;
    } catch (error) {
      const response = error.cause;
      showErrorMessage(response);
    } finally {
      ipcState.off();
    }
  };

  async function moodleAccountCreate(moodleData) {
    try {
      setIsMoodleAccountCreating.on();
        const res = await accountsRepository.moodleAccountCreate(moodleData);
        const toastProps = {
          header: 'Success!',
          description: `${'Moodle Account Created'}`,
        };
        successToast(toast, toastProps);
        return res;
    } catch (error) {
        const response = error.cause;
        showErrorMessage(response);
    }
    finally {
      setIsMoodleAccountCreating.off();
    }
  }

  async function moodleAccountUpdate(providerId, providerBody) {
    try {
      setIsMoodleAccountUpdating.on();
        const res = await accountsRepository.moodleAccountUpdate(
          providerId,
          providerBody
        );
        const toastProps = {
          header: 'Success!',
          description: `${'Moodle Account Updated'}`,
        };
        successToast(toast, toastProps);
        return res;
    } catch (error) {
        const response = error.cause;
        showErrorMessage(response);
    }
    finally {
      setIsMoodleAccountUpdating.off();
    }
  }

  async function moodleAccountDelete(moodleData) {
    try {
        setIsMoodleAccountDeleting.on();
        const res = await accountsRepository.moodleAccountDelete(moodleData);
        const toastProps = {
          header: 'Success!',
          description: `${'Moodle Account Deleted'}`,
        };
        successToast(toast, toastProps);
        return res;
    } catch (error) {
        const response = error.cause;
        showErrorMessage(response);
    }
    finally {
      setIsMoodleAccountDeleting.off();
    }
  }

  const syncProvidersWithMoodle = async (departmentId) => {
    try {
      setMoodleSyncLoading.on();
      const response = await accountsRepository.syncProvidersWithMoodle(departmentId); 
      // const toastProps = {
      //   header: 'Success!',
      //   description: `${'Synced Providers with Moodle'}`,
      // };
      // successToast(toast, toastProps);
      return response;
    } catch (error) {
        const response = error.cause;
        showErrorMessage(response);
    } finally {
      setMoodleSyncLoading.off();
    }
  };

  const getProvidersByDeparment = async (departmentId, queryParams) => {
    try {
      ifpState.on();
      const response = await accountsRepository.getProvidersByDeparment(
        departmentId,
        queryParams
      );
      setProviderData(response);
      return response;
    } catch (error) {
      toast.showError({ description: error.toString() });
    } finally {
      ifpState.off();
    }
  };

  const getProvider = async (providerId, queryParams = null) => {
    try {
      const response = await accountsRepository.getProvider(providerId, queryParams);
      setProvider(response);
      return response;
    } catch (error) {
      toast.showError({ description: error.toString() });
    }
  };
  const onProviderUpdate = async (providerId, providerBody) => {
    try {
      const response = await accountsRepository.onProviderUpdate(
        providerId,
        providerBody
      );

      // Update qualifications
      if (providerBody.qualification_ids) {
        await accountsRepository.qualificationToClient(response.id, providerBody.qualification_ids)
      }
      
      const toastProps = {
        header: 'Success!',
        description: `${'Provider Updated'}`,
      };
      successToast(toast, toastProps);
      return response;
    } catch (error) {
      const response = {errors: error.cause};
      showErrorMessage(response);
      return response
    }
  };

  const updatePartialProviderInfo = async (providerId, payload, isActivation = false) => {
    try {
      ipuState.on();
      const res = await accountsRepository.updatePartialProviderInformation(providerId, payload);

      const toastProps = {
        header: 'Success!',
        description: `${'Provider updated'}`,
      };
      successToast(toast, toastProps);
      return res;
    } catch (error) {
      showErrorMessage(error.cause);
      return {error: error?.cause?.detail || "ERROR"}
    } finally {
      ipuState.off();
    }
  }

  const onDeleteProvider = async providerId => {
    try {
      ipdState.on();
      const response = await accountsRepository.onDeleteProvider(providerId);
      const toastProps = {
        header: 'Success!',
        description: `${'Provider Deleted'}`,
      };
      successToast(toast, toastProps);
      return response;
    } catch (error) {
      toast.showError({ description: error.toString() });
    }finally{
      ipdState.off();
    }
  };

  const getDepartmentDropdown = async (hospitalId, all = false) => {
    try {
      const res = await accountsRepository.getDepartmentDropdown(hospitalId, {all: all});
      const data = res.map(d => ({ ...d, label: d.name, value: d.id }));
      setDepartmentDropdown(data);
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    }
  };
  const createHealthSystem = async payload => {
    try {
      ichsState.on();
      const response = await accountsRepository.createHealthSystem(payload);
      const toastProps = {
        header: 'Success!',
        description: `Health System Created Successfully`,
      };
      successToast(toast, toastProps);
      return response;
    } catch (e) {
      const response = e.cause;
      showErrorMessage(response)
    } finally {
      ichsState.off();
    }
  };

  const getHealthSystemNames = async () => {
    try {
      const response = await accountsRepository.healthSystemNamesAndPrefix();
      setHSnamesAndPrefix(response);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    }
  };

  const getUsersMailId = async () => {
    try {
      const response = await accountsRepository.cqUsersMailId();
      setUserMailIds(response);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    }
  };

  const cqHospitalsData = async () => {
    try {
      const response = await accountsRepository.cqHospitalsData();
      setHospitalDatas(response);
      return response;
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    }
  };

  //Qualifications
  // Get all qualifications
  const getQualifications = async () => {
    try {
      const response = await accountsRepository.getQualifications()
      return response;
    } catch (error) {
      throw error;
    }
  };

  // Create new qualification (only for managers)
  const createQualification = async (qualificationData) => {
    setIsQualificationCreating.on();
    try {
      const response = await accountsRepository.createQualification(qualificationData);
      return response;
    } catch (error) {
      const errorMsg = error?.cause?.qualification?.[0]
      || error?.message
      || 'Something went wrong';
      throw new Error(errorMsg);
    } finally {
      setIsQualificationCreating.off();
    }
  };

  async function getArchivedAccountsList(paginationParams) {
    try {
      ilaalState.on();
      const response = await accountsRepository.archivedAccountsList({
        ...paginationParams,
        ...archivedAccountFilters,
      });
      setArchivedAccountsList(response.results);
      setArchivedAccountListCount(response.count);
      return response;
    } catch (error) {
      
      toast.showError({
        description: `${error}`,
      });
    } finally {
      ilaalState.off();
    }
  }

  const restoreAccount = async accountId => {
    try {
      idlState.on();
      await accountsRepository.restoreAccount(accountId);
      const temps = archivedAccountsList.filter(account => account.id !== accountId);
      setArchivedAccountsList([...temps]);
      setArchivedAccountListCount(prev => prev - 1);
      const toastProps = {
        header: 'Success!',
        description: 'Account restored successfully.',
      };
      successToast(toast, toastProps);
      
    } catch (error) {
      toast.showError({
        description: `${error.toString()}`,
      });
    } finally {
      idlState.off();
    }
  };

  const mContext = {
    isLoadingAccountsList,
    accountsList,

    // specialty related
    specialtyOptions,
    isFetchingSpecialtyOption,
    isCreatingSpecialtyOption,
    fetchSpecialtyOptions,
    createSpecialtyOption,

    // insurance related
    insuranceOptions,
    isFetchingInsurance,
    isCreatingInsurance,
    fetchInsuranceOptions,
    createInsuranceOption,

    // ehr related
    ehrOptions,
    isFetchingEHR,
    isCreatingEHR,
    fetchEHROptions,
    createEHROptions,

    isDepartmentLoading,
    onDeleteDepartment,
    getDepartment,
    createDepartment,
    updateDepartment,
    updatePartialDepartmentInfo,
    isDepartmentUpdating,
    errorObject,

    getAccount,
    getHospital,
    account,
    hospital,
    department,
    allDeparments,
    provider,
    deleteAccount,
    getAccountDeletionPreview,
    permanentDeleteAccount,
    isPermanentDeleteLoading,

    getProviderEmailByKeyword,
    createProvider,
    // creating provider <Boolean/>
    isProviderCreating,
    isProviderDeleting,
    isProviderUpdating,
    moodleAccountCreate,
    isMoodleAccountCreating,
    moodleAccountUpdate,
    isMoodleAccountUpdating,
    moodleAccountDelete,
    isMoodleAccountDeleting,
    syncProvidersWithMoodle,
    moodleSyncLoading,
    getProvidersByDeparment,
    getProvider,
    onProviderUpdate,
    updatePartialProviderInfo,
    onDeleteProvider,

    getAccountsList: getAccountsList1,
    accountListCount,

    hospitalData,
    providerData,
    setProviderData,
    fetchHospital,
    isGettingHospitalData,
    createHospital,

    updateHospital,
    updatePartialHospitalInfo,
    isHospitalUpdating,
    onDeleteHospital,
    departmentDropdown,
    setDepartmentDropdown,
    getDepartmentDropdown,

    // create health System
    createHealthSystem,
    isCreatingHealthSystem,
    healthSystem,
    getHealthSystem,
    getAllDepartmentSByHS,
    isGettingHealthSystemData,
    isGettingAllDepartmentData,
    // update health system
    updateHealthSystemInformation,
    updatePartialHealthSystemInfo,
    isHealthSystemUpdating,
    isFetchingPhysicians,

    // healthsystem_validation
    getHealthSystemNames,
    hsNamesAndPrefix,

    // users MAil id
    getUsersMailId,
    usersMailIds,

    // hospital
    cqHospitalsData,
    hospitalDatas,
    // updated hospital list
    updatedHospitalList,
    isCreatingHospital,
    setAccountFilters,
    accountFilters,
    setSpecialtyOptions,

    //Qualification
    getQualifications,
    createQualification,

    //Archived Account
    archivedAccountsList,
    isLoadingArchivedAccountsList,
    getArchivedAccountsList: getArchivedAccountsList1,
    restoreAccount,
    archivedAccountFilters,
    setArchivedAccountFilters,

    handleApplyFilter
  };
  return (
    <AccountContext.Provider value={mContext}>
      {children}
    </AccountContext.Provider>
  );
};

export default AccountsProvider;
